import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import ConstantsModule from './modules/ConstantsModule';
import BusinessTaxiModule from './modules/BusinessTaxiModule';
import FamilyAirportTaxiModule from './modules/FamilyAirportTaxiModule';
import AirportTransfersSearchModule from './modules/AirportTransfersSearchModule';
import UserModule from './modules/UserModule';
import CsrfModule from './modules/CsrfModule';
import CoachesOrderModule from './modules/CoachesOrderModule';
import RegistrationModule from './modules/RegistrationModule';
import BusinessTravelManagementModule from './modules/BusinessTravelManagementModule';
import BerbusModule from './modules/BerbusModule';

Vue.use(Vuex);

const vuexPersistence = new VuexPersistence({
    modules: [
        'businessTaxi',
        'familyAirportTaxi',
        'coachesOrder',
        'register',
        'airportTransfersSearch',
        'businessTravelManagement',
        'berbus',
        'user',
    ],
});

let store = new Vuex.Store({
    modules: {
        constants: ConstantsModule,
        businessTaxi: BusinessTaxiModule,
        familyAirportTaxi: FamilyAirportTaxiModule,
        airportTransfersSearch: AirportTransfersSearchModule,
        user: UserModule,
        csrf: CsrfModule,
        coachesOrder: CoachesOrderModule,
        register: RegistrationModule,
        businessTravelManagement: BusinessTravelManagementModule,
        berbus: BerbusModule,
    },

    plugins: [
        vuexPersistence.plugin,
    ],
});

export default store;
